(function (createPolicy) {
  'use strict';
  if (typeof module === 'object' && module.exports) {
    module.exports = createPolicy;
    return;
  }
  window.ABMCartPolicy = createPolicy({
    fetch: window.fetch.bind(window),
    cartUrl: window.ABM.routes.cart,
    locks: navigator.locks,
    messages: window.ABM_SHIP.cartPolicy,
    parse: function (html) {
      var tag = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-shipping]');
      if (!tag) throw new Error('Missing cart data');
      return JSON.parse(tag.textContent);
    }
  });
  document.addEventListener('abm:cart', function (event) {
    var state = event.detail.ship;
    if (window.ABMCartPolicy.kind(state) === 'unknown') return;
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var blocked = window.ABMCartPolicy.addReason(state, form.dataset.deliveryCarrier);
      form.querySelectorAll('[data-add-button]').forEach(function (button) {
        button.disabled = !!blocked;
        button.textContent = blocked ? window.ABM_SHIP.cartPolicy.blockedButton : window.ABM_SHIP.cartPolicy.addLabel;
      });
      var error = form.querySelector('[data-cart-error]');
      if (error) { error.hidden = !blocked; error.textContent = blocked ? window.ABM_SHIP.cartPolicy[blocked] : ''; }
      var link = form.querySelector('[data-cart-policy-link]');
      if (link) link.hidden = !blocked;
    });
  });
})(function (env) {
  'use strict';
  var queue = Promise.resolve();
  function carrierKind(carrier) {
    if (carrier === 'pickup') return 'pickup';
    if (carrier === 'parcel' || carrier === 'freight') return 'shippable';
    return 'unknown';
  }
  function kind(state) {
    if (!state || !Number.isInteger(state.line_count) || state.line_count < 0 || !state.lines || typeof state.lines !== 'object') return 'unknown';
    var keys = Object.keys(state.lines);
    if (keys.length !== state.line_count) return 'unknown';
    var pickup = false, shippable = false;
    for (var i = 0; i < keys.length; i++) {
      var line = state.lines[keys[i]];
      var group = carrierKind(line && line.carrier);
      if (group === 'unknown') return 'unknown';
      pickup = pickup || group === 'pickup';
      shippable = shippable || group === 'shippable';
    }
    return pickup && shippable ? 'mixed' : pickup ? 'pickup' : shippable ? 'shippable' : 'empty';
  }
  function reason(state) {
    var group = kind(state);
    return group === 'unknown' ? 'unknown' : group === 'mixed' ? 'mixed' : '';
  }
  function addReason(state, carrier) {
    var current = kind(state), incoming = carrierKind(carrier);
    if (current === 'unknown' || incoming === 'unknown') return 'unknown';
    if (current === 'mixed' || (current === 'pickup' && incoming === 'shippable') || (current === 'shippable' && incoming === 'pickup')) return 'mixed';
    return '';
  }
  function failure(code) {
    var error = new Error(env.messages[code]);
    error.code = 'cart_delivery_policy';
    return error;
  }
  function read(productUrl) {
    var path = productUrl || env.cartUrl;
    return env.fetch(path.split('?')[0] + '?section_id=cart-shipping-data', { cache: 'no-store', headers: { Accept: 'text/html' } })
      .then(function (response) { if (!response.ok) throw failure('unknown'); return response.text(); })
      .then(function (html) {
        var state = env.parse(html);
        if (kind(state) === 'unknown') throw failure('unknown');
        return state;
      })
      .catch(function () { throw failure('unknown'); });
  }
  function add(productUrl, action) {
    function attempt() {
      if (!productUrl) return Promise.reject(failure('unknown'));
      return read(productUrl).then(function (state) {
        var code = addReason(state, state.candidate && state.candidate.carrier);
        if (code) throw failure(code);
        return action();
      });
    }
    if (env.locks && env.locks.request) return env.locks.request('abm-cart-delivery', attempt);
    var result = queue.then(attempt, attempt);
    queue = result.catch(function () {});
    return result;
  }
  function checkout() {
    return read().then(function (state) {
      var code = reason(state);
      if (code) throw failure(code);
      return state;
    });
  }
  return { kind: kind, reason: reason, addReason: addReason, add: add, checkout: checkout };
});
